import aframe from "aframe"

aframe.registerComponent("animation-event", {
    schema: {
        
    },
    
    init: function () {
        // if (!this.data.enabled) return
        
        console.log("is it in my head")

        this.el.addEventListener("animationstart", this.onBegin.bind(this))
        this.el.addEventListener("animationend", this.onEnd.bind(this))
        
    },

    onBegin: function (e) {
        console.log("onBegin")
    },

    onEnd: function(e) {
        console.log("onEnd")
    },
})


// WEBPACK FOOTER //
// ./src/components-aframe/animationEvents.js